import axios from 'axios';

const api = axios.create({
  baseURL: 'https://appapi.hebei.com.cn/api/2026ljytzdshd/api/',
  timeout: 60000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
});

export default api;